import { TitleCasePipe } from "@angular/common";
import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from "@angular/core";
import { MessageService } from "primeng/api";
import SignaturePad from "signature_pad";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { SOObjectNames } from "src/app/inventory/sales-order/constants/constants";
import { Severity } from "../../constants/constants";
import { ISignature, ISignatureFile } from "../models/signature";
import { OrdersService } from "../orders.service";
import { SignatureType } from "../../constants/constants";

@Component({
    selector: "app-signature",
    templateUrl: "./signature.component.html",
    styleUrls: ["./signature.component.scss"],
})
export class SignatureComponent implements OnInit, AfterViewInit {

    @ViewChild("canvas") canvasEl: ElementRef;
    @ViewChild("canvas2") canvasEl2: ElementRef;
    @ViewChild("canvas3") canvasEl3: ElementRef;
    @ViewChild("canvas4") canvasEl4: ElementRef;

    estimateSignaturePad: SignaturePad;
    salesOrderSignaturePad: SignaturePad;
    invoiceSignaturePad: SignaturePad;
    creditMemoSignaturePad: SignaturePad;

    // pre loaded obj
    estimateObj: any;
    soObj: any;
    invoiceObj: any;
    creditMemoObj: any;

    estimateSignature: ISignature;
    salesOrderSignature: ISignature;
    invoiceSignature: ISignature;
    creditMemoSignature: ISignature;
    signatureType = SignatureType;

    constructor(public app: AppMainComponent,
        private ordersService: OrdersService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
    ) { }

    ngOnInit(): void {
        this.loadPreLoadedObjects();
        this.getAllSignature();
    }

    loadPreLoadedObjects() {
        this.estimateObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.Estimate
        );
        this.soObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.SalesOrder
        );
        this.invoiceObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.Invoice
        );
        this.creditMemoObj = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.CreditMemo
        );
    }

    ngAfterViewInit() {
        this.estimateSignaturePad = new SignaturePad(this.canvasEl.nativeElement);
        this.salesOrderSignaturePad = new SignaturePad(this.canvasEl2.nativeElement);
        this.invoiceSignaturePad = new SignaturePad(this.canvasEl3.nativeElement);
        this.creditMemoSignaturePad = new SignaturePad(this.canvasEl4.nativeElement);
    }

    getAllSignature() {
        this.appMainService.isShowSpinner("loadSignature");
        this.ordersService.getAllSignature(this.app.companyId).subscribe(
            (res: ISignature[]) => {
                this.appMainService.isHideSpinner("loadSignature");
                this.estimateSignature = res?.find(r => r.objectId == this.estimateObj?.id);
                this.salesOrderSignature = res?.find(r => r.objectId == this.soObj?.id);
                this.invoiceSignature = res?.find(r => r.objectId == this.invoiceObj?.id);
                this.creditMemoSignature = res?.find(r => r.objectId == this.creditMemoObj?.id);
            },
            (error) => {
                this.appMainService.isHideSpinner("loadSignature");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            });
    }

    saveSignature(obj: any, attachmentId: number) {
        const data: ISignature = {
            id: 0,
            organizationId: this.app.companyId,
            objectId: obj.id,
            objectName: obj.name,
            attachmentId: attachmentId,
            attachmentImage: null,
            msg: "",
            statusId: 1,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
        }
        this.ordersService.saveSignature(data).subscribe(res => {
            this.getAllSignature();
        });
    }

    updateSignature(signature: ISignature, attachmentId: number) {
        const data: ISignature = {
            id: signature.id,
            organizationId: this.app.companyId,
            objectId: signature.objectId,
            objectName: signature.objectName,
            attachmentId: attachmentId,
            attachmentImage: null,
            msg: signature.msg,
            statusId: 1,
            createdSource: signature.createdSource,
            updatedSource: this.app.userIP,
            createdBy: signature.createdBy,
            updatedBy: this.app.user.userId,
            createdDate: signature.createdDate,
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
        }
        this.ordersService.updateSignature(data).subscribe(res => {
            this.getAllSignature();
        });
    }

    savePad(type) {
        let base64Data = null;
        let signatureObj = null;
        let moduleObj = null;

        switch (type) {
            case SignatureType.Estimate:
                base64Data = this.estimateSignaturePad.toDataURL();
                signatureObj = this.estimateSignature;
                moduleObj = this.estimateObj;
                break;
            case SignatureType.SalesOrder:
                base64Data = this.salesOrderSignaturePad.toDataURL();
                signatureObj = this.salesOrderSignature;
                moduleObj = this.soObj;
                break;
            case SignatureType.Invoice:
                base64Data = this.invoiceSignaturePad.toDataURL();
                signatureObj = this.invoiceSignature;
                moduleObj = this.invoiceObj;
                break;
            case SignatureType.CreditMemo:
                base64Data = this.creditMemoSignaturePad.toDataURL();
                signatureObj = this.creditMemoSignature;
                moduleObj = this.creditMemoObj;
                break;
        }
        const imageData = base64Data.replace(/^data:image\/(png|jpg);base64,/, "");
        const signatureData: ISignatureFile = {
            id: 0,
            name: type,
            content: imageData,
            extension: 'png',
            moduleName: 'Signature',
            statusId: 1
        }
        this.ordersService.uploadFile(signatureData).subscribe(
            (res) => {
                if (signatureObj) {
                    this.updateSignature(signatureObj, res.id)
                } else {
                    this.saveSignature(moduleObj, res.id);
                }
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            });
    }

    clearPad(type) {
        switch (type) {
            case SignatureType.Estimate:
                this.estimateSignaturePad.clear();
                break;
            case SignatureType.SalesOrder:
                this.salesOrderSignaturePad.clear();
                break;
            case SignatureType.Invoice:
                this.invoiceSignaturePad.clear();
                break;
            case SignatureType.CreditMemo:
                this.creditMemoSignaturePad.clear();
                break;
        }
    }

    startDrawing(event: Event) {
        // console.log(event);
        // works in device not in browser
    }

    moved(event: Event) {
        // works in device not in browser
    }
}
